import React, { useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import MyContext from "../MyContext/MyContext";

// ALERT UI
const Alert = ({ type, children }) => {
  const styles = {
    padding: "10px 14px",
    borderRadius: 6,
    marginBottom: 12,
    color: type === "success" ? "#064e3b" : "#6b0219",
    background: type === "success" ? "#bbf7d0" : "#fecaca",
    border: `1px solid ${type === "success" ? "#bbf7d0" : "#fecaca"}`,
    fontSize: 14,
  };
  return <div style={styles}>{children}</div>;
};

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { resetPassword } = useContext(MyContext);

  const [showPass, setShowPass] = useState(false);

  return (
    <section
      className="py-80"
      style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}
    >
      <div className="container container-sm">
        <div className="row justify-content-center">
          <div className="col-md-6">

            <div className="border rounded-16 px-24 py-40">

              <h4 className="mb-20 text-center">Create a New Password</h4>
              <p style={{ marginBottom: 18, color: "#555", textAlign: "center" }}>
                Your reset link is valid for one hour.
              </p>

              <Formik
                initialValues={{ password: "", confirm: "" }}
                onSubmit={async (values, { setSubmitting, setStatus }) => {
                  setStatus(null);

                  if (values.password !== values.confirm) {
                    setStatus({ error: "Passwords do not match." });
                    setSubmitting(false);
                    return;
                  }

                  try {
                    const res = await resetPassword(token, values.password);

                    if (!res.success) {
                      setStatus({ error: res.error });
                    } else {
                      setStatus({ success: res.message });

                      setTimeout(() => navigate("/"), 1500);
                    }
                  } catch {
                    setStatus({ error: "Something went wrong." });
                  } finally {
                    // Let LoaderWrapper show global loader while redirecting
                    setSubmitting(false);
                  }
                }}
              >
                {({ isSubmitting, status }) => (
                  <Form>
                    {status?.error && <Alert type="error">{status.error}</Alert>}
                    {status?.success && <Alert type="success">{status.success}</Alert>}

                    {/* NEW PASSWORD */}
                    <div className="mb-12">
                      <label>New Password</label>
                      <div style={{ position: "relative" }}>
                        <Field
                          type={showPass ? "text" : "password"}
                          name="password"
                          className="common-input"
                          required
                        />

                        <button
                          type="button"
                          onClick={() => setShowPass((s) => !s)}
                          style={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            fontSize: 13,
                          }}
                        >
                          {showPass ? "Hide" : "Show"}
                        </button>
                      </div>
                    </div>

                    {/* CONFIRM PASSWORD */}
                    <div className="mb-12">
                      <label>Confirm Password</label>
                      <Field
                        type={showPass ? "text" : "password"}
                        name="confirm"
                        className="common-input"
                        required
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-main w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Resetting..." : "Reset Password"}
                    </button>
                  </Form>
                )}
              </Formik>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
